module.exports = __webpack_public_path__ + "static/media/Dai.a9600585.png";